export const reward_system_permission = {
  dashboard_card_permissions: ["view_pointtransaction", "view_rewardpoint"],
  reward_overview_permissions: ["view_pointtransaction", "view_rewardpoint", "view_rewardmodule"],
  reward_history_permissions: ["view_rewardpoint"],
  reward_earn_more_permissions: ["view_rule"],
  reward_redeem: ["view_pointtransaction", "view_reward", "add_redeempoint"]
}